import { format } from 'date-fns';
import { statelessClientDateFunction } from './useClientDate';

export const getLocalizedBookingDateTime = (date: string, time: string, timezone?: string) => {
  const bookingDateTime = {
    date,
    time: time || '',
  };

  if (!timezone) {
    return bookingDateTime;
  }

  const formattedDate = `${date}T${time}`;

  const { date: localBookingDateTime } = statelessClientDateFunction(
    'yyyy-MM-dd kk:mm',
    timezone,
    formattedDate,
    true,
  );

  if (!localBookingDateTime) {
    return bookingDateTime;
  }

  const localDate = format(localBookingDateTime, 'yyyy-MM-dd');
  const localTime = format(localBookingDateTime, 'HH:mm');

  return {
    date: localDate,
    time: localTime,
  };
};
